import React from 'react';
import { MODAL_STYLES } from '../../constants/styles';
import OrderSummaryContent from '../OrderSummary/OrderSummaryContent';

/**
 * Modal wrapper for Order Summary (used on tablet & mobile)
 */
const SummaryModal = ({ ordersByDeliveryDate, deliveryDates, onClose, billingChanges, customerToken, pendingChanges, priorPaymentsByDate, paymentRecords, onSaveSuccess, customerDetails, deliveryTimeOverrides, onDeliveryTimeChange }) => {
    return (
        <div
            className="summary-modal-container"
            style={MODAL_STYLES.overlay}
            onClick={onClose}
        >
            <div
                className='summary-modal'
                style={{
                    ...MODAL_STYLES.content,
                    maxHeight: '80vh',
                    width: '600px',
                    maxWidth: '90vw'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    style={MODAL_STYLES.closeButton}
                >
                    ×
                </button>
                <OrderSummaryContent
                    ordersByDeliveryDate={ordersByDeliveryDate}
                    deliveryDates={deliveryDates}
                    billingChanges={billingChanges}
                    customerToken={customerToken}
                    pendingChanges={pendingChanges}
                    priorPaymentsByDate={priorPaymentsByDate}
                    paymentRecords={paymentRecords}
                    onSaveSuccess={onSaveSuccess}
                    variant="modal"
                    customerDetails={customerDetails}
                    deliveryTimeOverrides={deliveryTimeOverrides}
                    onDeliveryTimeChange={onDeliveryTimeChange}
                />
            </div>
        </div>
    );
};

export default SummaryModal;
